angular.module("ainapp")
    .controller("addEmployeeController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Employee";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.ParentList = [];
            MainService.GetEmployeeParentList().then(function (response) {
                $scope.ParentList = response.data;
            });


            $scope.Countries = [];
            MainService.CountriesInDropdown().then(function (response) {
                $scope.Countries = response.data;
            })

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                $scope.Branches = response.data;
            })

            $scope.Designations = [];
            MainService.DesignationsInDropdown().then(function (response) {
                $scope.Designations = response.data;
            })

            $scope.Departments = [];
            MainService.DepartmentsInDropdown().then(function (response) {
                $scope.Departments = response.data;
            })

            $scope.EmployeeArray = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.EmployeeArray = response.data;
            })

            $scope.Grades = [];
            MainService.GradesInDropdown().then(function (response) {
                $scope.Grades = response.data;
            })

            $scope.Shifts = [];
            MainService.ShiftsInDropdown().then(function (response) {
                $scope.Shifts = response.data;
            })

            $scope.Banks = [];
            MainService.BanksInDropdown().then(function (response) {
                $scope.Banks = response.data;
            })

            $scope.CostCenters = [];
            MainService.GetAllCostSubCenters().then(function (response) {
                $scope.CostCenters = response.data;
            })

            $scope.updateDetails = function () {

                MainService.EmployeeById($stateParams.EmployeeId).then(function (response) {
                    if (response.data) {
                        $scope.Employee = response.data;

                        $scope.Employee.BirthDate = new Date($scope.Employee.BirthDate);
                        $scope.Employee.InterviewDate = new Date($scope.Employee.InterviewDate);
                        $scope.Employee.DesignationDate = new Date($scope.Employee.DesignationDate);
                        $scope.Employee.StartingDate = new Date($scope.Employee.StartingDate);
                        $scope.Employee.ResignationDate = new Date($scope.Employee.ResignationDate);
                        $scope.Employee.EndingDate = new Date($scope.Employee.EndingDate);
                        $scope.Employee.DateOfJoining = new Date($scope.Employee.DateOfJoining);
                        $scope.Employee.ConfirmationDate = new Date($scope.Employee.ConfirmationDate);
                        $scope.Employee.PassportIssueDate = new Date($scope.Employee.PassportIssueDate);
                        $scope.Employee.PassportIExpireDate = new Date($scope.Employee.PassportIExpireDate);
                        $scope.Employee.VisaIssueDate = new Date($scope.Employee.VisaIssueDate);
                        $scope.Employee.VisaExpireDate = new Date($scope.Employee.VisaExpireDate);
                        $scope.Employee.LabourCardIssueDate = new Date($scope.Employee.LabourCardIssueDate);
                        $scope.Employee.LabourCardExpiryDate = new Date($scope.Employee.LabourCardExpiryDate);
                        $scope.Employee.ContractIssueDate = new Date($scope.Employee.ContractIssueDate);
                        $scope.Employee.ContractExpiryDate = new Date($scope.Employee.ContractExpiryDate);
                        $scope.Employee.ContractExpendableDate = new Date($scope.Employee.ContractExpendableDate);
                        $scope.Employee.IDIssueDate = new Date($scope.Employee.IDIssueDate);
                        $scope.Employee.IDExpiryDate = new Date($scope.Employee.IDExpiryDate);
                        $scope.Employee.DrivingLicenseIssueDate = new Date($scope.Employee.DrivingLicenseIssueDate);
                        $scope.Employee.DrivingLicenseExpiryDate = new Date($scope.Employee.DrivingLicenseExpiryDate);
                        $scope.Employee.MedicalIssueDate = new Date($scope.Employee.MedicalIssueDate);
                        $scope.Employee.MedicalExpiryDate = new Date($scope.Employee.MedicalExpiryDate);
                        $scope.Employee.OHCIssueDate = new Date($scope.Employee.OHCIssueDate);
                        $scope.Employee.OHCExpiryDate = new Date($scope.Employee.OHCExpiryDate);
                        $scope.Employee.DateAsOn = new Date($scope.Employee.DateAsOn);

                        $scope.PayrollComponents = [];
                        MainService.PayrollComponentsInEmployee().then(function (response2) {
                            $scope.PayrollComponents = response2.data;
                            angular.forEach($scope.PayrollComponents, function (e) {

                                var found = 0;
                                angular.forEach($scope.Employee.EmployeePayrolls, function (a) {
                                    if (a.PayrollComponentId == e.Id) {
                                        found = 1;
                                    }
                                })

                                if (found == 0) {
                                    var temp = {
                                        Type: e.Type,
                                        PayrollComponentId: e.Id,
                                        PayrollComponent: e,
                                        Amount: 0,
                                    }
                                    $scope.Employee.EmployeePayrolls.push(temp);
                                }


                            })
                        })


                    }
                    $scope.load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = false;
                })


            }



            $scope.Init = function () {

                $scope.Employee = {
                    Name: "",
                    CountryId: "",
                    EmployeeId: "",
                    BranchId: "",
                    Email: "",
                    MobileNo: "",
                    TelephoneNo: "",
                    Address: "",
                    DepartmentId: "",
                    DesignationId: "",
                    Image: "",
                    FirstName: "",
                    SurName: "",
                    FatherName: "",
                    MotherName: "",
                    Gender: "",
                    BirthPlace: "",
                    PassportNo: "",
                    Religion: "",
                    VisaType: "",
                    VisaNo: "",
                    JobLocation: "",
                    ContractNo: "",
                    BloodGroup: "",
                    MaritalStatus: "",
                    WhatsappNo: "",
                    HomeCountryAddress: "",
                    Insurance: "",
                    ReferenceFriendName: "",
                    ReferenceFriendNo: "",
                    DesignationId: "",
                    DepartmentId: "",
                    ReportingManagerId: "",

                    BirthDate: null,
                    InterviewDate: null,
                    DesignationDate: null,
                    StartingDate: null,
                    ResignationDate: null,
                    EndingDate: null,
                    DateOfJoining: null,
                    ConfirmationDate: null,
                    PassportIssueDate: null,
                    PassportIExpireDate: null,
                    VisaIssueDate: null,
                    VisaExpireDate: null,
                    LabourCardIssueDate: null,
                    LabourCardExpiryDate: null,
                    ContractIssueDate: null,
                    ContractExpiryDate: null,
                    ContractExpendableDate: null,
                    IDIssueDate: null,
                    IDExpiryDate: null,
                    DrivingLicenseIssueDate: null,
                    DrivingLicenseExpiryDate: null,
                    MedicalIssueDate: null,
                    MedicalExpiryDate: null,
                    OHCIssueDate: null,
                    OHCExpiryDate: null,
                    DateAsOn: null,

                    EmployeeContacts: [],
                    EmployeeAddress: [],
                    EmployeePayrolls: [],
                    EmployeeCostCenters: [],
                }



                $scope.load = 0;
                $scope.ViewVal = 0;
                $scope.filter = {};


                $scope.Contact = {
                    Name: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    Relation: "",
                    IsActive: true,
                }

                $scope.Employee.EmployeeContacts.push($scope.Contact);

                $scope.costcenter = {
                    Percentage: 0,
                    CostCenterId: "",
                    IsActive: true,
                }

                $scope.Employee.EmployeeCostCenters.push($scope.costcenter);

                $scope.Address = {
                    Name: "",
                    Type: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    IsActive: true,
                }
                $scope.Employee.EmployeeAddress.push($scope.Address);



                if ($stateParams.EmployeeId > 0) {

                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.Profile = response.data;
                    })

                    $scope.updateDetails();
                } else {

                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.Profile = response.data;
                        if ($scope.Profile.IEmployeeAutoCode) {
                            MainService.GetNextEmployeeNo().then(function (response) {
                                $scope.Employee.EmployeeId = response.data;
                            })
                        }
                    })

                    $scope.PayrollComponents = [];
                    MainService.PayrollComponentsInEmployee().then(function (response) {
                        $scope.PayrollComponents = response.data;
                        angular.forEach($scope.PayrollComponents, function (e) {
                            var temp = {
                                Type: e.Type,
                                PayrollComponentId: e.Id,
                                PayrollComponent: e,
                                Amount: 0,
                            }
                            $scope.Employee.EmployeePayrolls.push(temp);
                        })
                    })

                }

            }
            $scope.Init();

            $scope.handleFileSelect = function (evt) {
                var file = evt.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.myImage = evt.target.result;
                        $scope.Employee.Image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };


            $scope.AddContact = function (data) {
                $scope.Contact = {
                    Name: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    Relation: "",
                    IsActive: true,
                }
                $scope.Employee.EmployeeContacts.push($scope.Contact);
            }
            $scope.RemoveContact = function (data) {
                data.IsActive = false;
            }

            $scope.AddCostCenter = function (data) {
                $scope.costcenter = {
                    Percentage: 0,
                    CostCenterId: "",
                    IsActive: true,
                }

                $scope.Employee.EmployeeCostCenters.push($scope.costcenter);
            }
            $scope.RemoveCostCenter = function (data) {
                data.IsActive = false;
            }

            $scope.AddAddress = function (data) {
                $scope.Address = {
                    Name: "",
                    Type: "",
                    EmailId: "",
                    MobileNo1: "",
                    MobileNo2: "",
                    Address1: "",
                    Address2: "",
                    IsActive: true,
                }
                $scope.Employee.EmployeeAddress.push($scope.Address);
            }
            $scope.RemoveAddress = function (data) {
                data.IsActive = false;
            }

            $scope.calculateNetSalary = function () {
                $scope.Employee.NetSalary = 0;
                angular.forEach($scope.Employee.EmployeePayrolls, function (e) {
                    $scope.Employee.NetSalary = $scope.Employee.NetSalary + e.Amount;
                })
            }


            $scope.SelectedDataForDelete = {};
            $scope.DeleteVoucher = function (dataDel) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = dataDel;
                    $('#deleteModal').modal('show');
                }
            }

            $scope.DeleteWithConfirm = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });


                MainService.DeleteEmployee($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.Load = false;
                        $scope.SelectedDataForDelete = {};
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $('#deleteModal').modal('hide');
                        $scope.Init();
                    } else {
                        toastr.error($scope.NetworkErrorLan);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                })
            }


            $scope.AddData = function () {

                if (!$scope.PageAccessInfo.IsAdd && !$scope.Employee.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Employee.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                } else if ($scope.Employee.Name == "") {
                    toastr.warning("Enter the name");


                } else if ($scope.Employee.MobileNo == "") {
                    toastr.warning("Enter Mobile No");

                } else {

                    if ($scope.Employee.BirthDate != null) {
                        $scope.Employee.BirthDateString = $scope.extractDate($scope.Employee.BirthDate);
                    }
                    if ($scope.Employee.InterviewDate != null) {
                        $scope.Employee.InterviewDateString = $scope.extractDate($scope.Employee.InterviewDate);
                    }
                    if ($scope.Employee.DesignationDate != null) {
                        $scope.Employee.DesignationDateString = $scope.extractDate($scope.Employee.DesignationDate);
                    }
                    if ($scope.Employee.StartingDate != null) {
                        $scope.Employee.StartingDateString = $scope.extractDate($scope.Employee.StartingDate);
                    }
                    if ($scope.Employee.ResignationDate != null) {
                        $scope.Employee.ResignationDateString = $scope.extractDate($scope.Employee.ResignationDate);
                    }
                    if ($scope.Employee.EndingDate != null) {
                        $scope.Employee.EndingDateString = $scope.extractDate($scope.Employee.EndingDate);
                    }
                    if ($scope.Employee.DateOfJoining != null) {
                        $scope.Employee.DateOfJoiningString = $scope.extractDate($scope.Employee.DateOfJoining);
                    }
                    if ($scope.Employee.ConfirmationDate != null) {
                        $scope.Employee.ConfirmationDateString = $scope.extractDate($scope.Employee.ConfirmationDate);
                    }
                    if ($scope.Employee.PassportIssueDate != null) {
                        $scope.Employee.PassportIssueDateString = $scope.extractDate($scope.Employee.PassportIssueDate);
                    }
                    if ($scope.Employee.PassportIExpireDate != null) {
                        $scope.Employee.PassportIExpireDateString = $scope.extractDate($scope.Employee.PassportIExpireDate);
                    }
                    if ($scope.Employee.VisaIssueDate != null) {
                        $scope.Employee.VisaIssueDateString = $scope.extractDate($scope.Employee.VisaIssueDate);
                    }
                    if ($scope.Employee.VisaExpireDate != null) {
                        $scope.Employee.VisaExpireDateString = $scope.extractDate($scope.Employee.VisaExpireDate);
                    }
                    if ($scope.Employee.LabourCardIssueDate != null) {
                        $scope.Employee.LabourCardIssueDateString = $scope.extractDate($scope.Employee.LabourCardIssueDate);
                    }
                    if ($scope.Employee.LabourCardExpiryDate != null) {
                        $scope.Employee.LabourCardExpiryDateString = $scope.extractDate($scope.Employee.LabourCardExpiryDate);
                    }
                    if ($scope.Employee.ContractIssueDate != null) {
                        $scope.Employee.ContractIssueDateString = $scope.extractDate($scope.Employee.ContractIssueDate);
                    }
                    if ($scope.Employee.ContractExpiryDate != null) {
                        $scope.Employee.ContractExpiryDateString = $scope.extractDate($scope.Employee.ContractExpiryDate);
                    }
                    if ($scope.Employee.ContractExpendableDate != null) {
                        $scope.Employee.ContractExpendableDateString = $scope.extractDate($scope.Employee.ContractExpendableDate);
                    }
                    if ($scope.Employee.IDIssueDate != null) {
                        $scope.Employee.IDIssueDateString = $scope.extractDate($scope.Employee.IDIssueDate);
                    }
                    if ($scope.Employee.IDExpiryDate != null) {
                        $scope.Employee.IDExpiryDateString = $scope.extractDate($scope.Employee.IDExpiryDate);
                    }
                    if ($scope.Employee.DrivingLicenseIssueDate != null) {
                        $scope.Employee.DrivingLicenseIssueDateString = $scope.extractDate($scope.Employee.DrivingLicenseIssueDate);
                    }
                    if ($scope.Employee.DrivingLicenseExpiryDate != null) {
                        $scope.Employee.DrivingLicenseExpiryDateString = $scope.extractDate($scope.Employee.DrivingLicenseExpiryDate);
                    }
                    if ($scope.Employee.MedicalIssueDate != null) {
                        $scope.Employee.MedicalIssueDateString = $scope.extractDate($scope.Employee.MedicalIssueDate);
                    }
                    if ($scope.Employee.MedicalExpiryDate != null) {
                        $scope.Employee.MedicalExpiryDateString = $scope.extractDate($scope.Employee.MedicalExpiryDate);
                    }
                    if ($scope.Employee.OHCIssueDate != null) {
                        $scope.Employee.OHCIssueDateString = $scope.extractDate($scope.Employee.OHCIssueDate);
                    }
                    if ($scope.Employee.OHCExpiryDate != null) {
                        $scope.Employee.OHCExpiryDateString = $scope.extractDate($scope.Employee.OHCExpiryDate);
                    }
                    if ($scope.Employee.DateAsOn != null) {
                        $scope.Employee.DateAsOnString = $scope.extractDate($scope.Employee.DateAsOn);
                    }


                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.AddEmployee($scope.Employee).then(function (response) {
                        if (response.data == 1) {
                            toastr.success("Success");
                            $scope.Init();
                        } else if (response.data == 2) {
                            toastr.error("Username Exist");
                            $scope.load = 0;
                        } else {
                            toastr.error("Error");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }
            }


            $scope.goAttachments = function () {
                $state.go("attachmentByEmployee", {
                    EmployeeId: $scope.Employee.Id
                });
            }

            $scope.goAppraisals = function () {
                $state.go("appraisalsByEmployee", {
                    EmployeeId: $scope.Employee.Id
                });
            }


        }])
